"use client"

import React, {useCallback, useMemo, useState} from "react";
import styles from "./style.module.css";
import { faSearch} from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { Folder } from "../../types/fileDetails";

export const SearchLinkList = ({folders}: {
  folders: Array<Folder>
}) => {
  const [ search, setSearch ] = useState('')
  const filteredFolders = useMemo(() => {
    return folders.filter((folder) => {
      return folder.name?.toLowerCase().includes(search.toLowerCase())
    })
  }, [search, folders])
  const setSearchValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }, [])
  return (
    <>
      <div className={styles.searchLinkInput}>
        <FontAwesomeIcon icon={faSearch}/>
        <input value={search} onChange={setSearchValue} placeholder='search'/>
      </div>
      <div className={styles.searchLinkList}>
        {filteredFolders.map((folder) => {
          const data = folder.data
          return (
            <Link className={styles.link} href={`/photos/${folder.id}`} key={folder.id}>
              <div  className={styles.linkFallback}>
              {folder.preview  && !data?.isSensitive ? (
                <Image
                  src={`https://lh3.googleusercontent.com/d/${folder.preview}=s600`}
                  alt='preview image'
                  unoptimized
                  height={600}
                  width={0}
                  className={styles.linkImage}
                />
              ) : null}
              </div>
              <div className={styles.linkContent}>
                {folder.name ?? ''}
              </div>
            </Link>
          )
        })}
      </div>
    </>
  )
}
